import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box } from "@mui/material";

export default function TableSection({ title, columns, rows, emptyMessage, description }) {
  return (
    <Paper elevation={0} sx={{ p: 2, border: "1px solid #e0e0e0", borderRadius: "8px", mb: 2, background: '#fafbfc' }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>{title}</Typography>
        {description && (
          <Typography variant="body2" sx={{ color: '#607d8b', mt: 0.5 }}>{description}</Typography>
        )}
      </Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.field} sx={{ fontWeight: 700 }}>{col.headerName}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <TableRow key={idx}>                  {columns.map((col) => (
                    <TableCell key={col.field}>{col.format ? col.format(row[col.field]) : row[col.field]}</TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  {emptyMessage}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
